export const VEHICLE_STATUS = {
  0: "Unknown",
  1: "Ride In-progress",
  2: "In Maintenance",
  3: "Marked Broken",
  4: "Idle",
  5: "Retired",
};

export const VEHICLE_SERVICE_STATUS = {
  0: "Unknown",
  1: "Operational",
  2: "In Maintenance",
  3: "Marked Broken",
  4: "Retired",
};

export const VEHICLE_FUNCTIONAL_STATUS = {
  1: "ON",
  2: "OFF",
};

export const NOTIFICATION_PRIORITY_STATUS = ["","High","Medium","Low"];

export const ISSUE_STATUS = {
  0: "Unknown",
  1: "Completed",
  2: "Pending",
  3: "Cancelled",
};

export const ISSUE_TYPE = {
  0: "Unknown",
  1: "Accident",
  2: "Service",
  3: "Vehicle Missing",
  4: "Breakdown",
  5: "Roadside Breakdown",
  6: "Account Related"
};
export const KIOSK_ISSUE_TYPE = {
  0: "Other",
  1: "Electrical failure",
  2: "Fire or smoke",
  3: "Temperature rise",
  4: "Battery swap",
  5: "Mechanical failure",
  6: "Noise",
};

export const USER_TYPE = {
  0: "No role assigned",
  1: "Super Admin",
  2: "Fleet Owner Admin",
  3: "Rider",
  4: "Mechanic",
  5: "Fleet Client Admin",
  6: "Operations Monitor",
  7: "Customer Manager",
  8: "Production Manager"
};

export const USER_TYPE_ENUM = {
  0: "No role assigned",
  1: "Super Admin",
  2: "Fleet Owner Admin",
  3: "Rider",
  4: "Mechanic",
  5: "Fleet Client Admin",
  6: "OPERATOR",
  7: "Customer Manager",
  8: "Production Manager"
};

export const CLIENTS = {
  0: "Foodpanda",
  1: "TCS",
  2: "Leopard Courier",
  3: "M&P Courier",
  4: "Careem",
  5: "Bikea",
  6: "Uber",
};


export const BATTERY_STATUS = [
  "Inventory",      // index 0
  "Operational",  // index 1
  "In-Maintenance", // index 2
  "Retired" ,      // index 3
  "Offline",

];


export const MODEL_TYPE = {
  0: "No Type Select",
  1: "Two Wheeler",
  2: "Three Wheeler",
};

export const VEHICLE_COLOR_TYPE = {
  0: "No Color Select",
  1: "Red",
  2: "Sky Blue",
  3: "Beige",
  4: "Chrome Silver",
  5: "Black",
  6: "Gun Metal Silver",
};

export const VEHICLE_COLOR_CODE = {
  0: "#FFFFFF",
  1: "#ED2020",
  2: "#6da9e9",
  3: "#F5F5DC",
  4: "#b9b7b8",
  5: "#000000",
  6: "#5d5c62",
};


export const modelTypes = [
  { value: 1, label: "Two Wheeler" },
  { value: 2, label: "Three Wheeler" },
];


export const vehicleColors = [
  { value: 1, label: "Red" },
  { value: 2, label: "Sky Blue" },
  { value: 3, label: "Beige" },
  { value: 4, label: "Chrome Silver" },
  { value: 5, label: "Black" },
  { value: 6, label: "Gun Metal Silver" },
];




